/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Domains permissions granted to the team
 */
export type PublicTeamPermissionAssignmentDto = {
    /**
     * Id of the domain
     */
    domainId: string;
    /**
     * Domain role assigned to the team for accessing the referenced domain
     */
    domainRole: PublicTeamPermissionAssignmentDto.domainRole;
};

export namespace PublicTeamPermissionAssignmentDto {

    /**
     * Domain role assigned to the team for accessing the referenced domain
     */
    export enum domainRole {
        EDITOR = 'EDITOR',
        MONITOR_RESPONDER = 'MONITOR_RESPONDER',
        CATALOG_EDITOR = 'CATALOG_EDITOR',
        VIEWER = 'VIEWER',
    }


}
